// extracted by mini-css-extract-plugin
export var audioPlayer = "_td-0";